import { customThemeStyles } from 'common/theme.js';
export const dataViewsTheme = (theme) => ({
    ...customThemeStyles,
    deleteColumn: { width: "100px!important"},
    nameColumn: { width: "300px!important", wordBreak: "break-all!important" },
    databaseColumn: { width: "215px!important", wordBreak: "break-all!important" },
});